<template lang="pug">
  form.form.has-bottom(
    :class='classList'
    @submit.prevent='login'
    @input='resetError'
    novalidate
  )
    .form__top
      .form__header
        h1.form__title {{ $l10n("ENTRY") }}

      .form__body
        .form__async-errors(
          v-if='asyncError'
        )
          .form__error {{ asyncError }}

        label.form__control(
          :class="{ 'has-error': $v.form.email.$invalid }"
        )
          span.form__field
            Input(
              v-model='form.email'
              :set-focus='true'
              :placeholder='$l10n("YOUR_EMAIL")'
              name='email'
              type='email'
            )
          span.form__errors(v-if='$v.form.email.$invalid')
            span.form__error(v-if="!$v.form.email.required") {{ $l10n("VALIDATION_REQUIRED_FIELD") }}
            span.form__error(v-if="!$v.form.email.email") {{ $l10n("VALIDATION_NOTVALID_EMAIL") }} 

        label.form__control(
          :class="{ 'has-error': $v.form.password.$invalid }"
        )
          span.form__field
            Input(
              v-model='form.password' 
              :placeholder='$l10n("YOUR_PASSWORD")'
              name='password'
              type='password'
            )
          span.form__errors(v-if='$v.form.password.$invalid')
            span.form__error(v-if="!$v.form.password.required") {{ $l10n("VALIDATION_REQUIRED_FIELD") }}
            span.form__error(v-if="!$v.form.password.minLength") {{ $l10n("VALIDATION_PASSWORD_MIN_LENGHT", { length: $v.form.password.$params.minLength.min }) }}

        .form__control
          .form__row
            .form__checkbox
              Checkbox(
                v-model='form.remember' 
                :label='$l10n("REMEMBER_ME")'
                name='remember'
              )
            button.form__link(
              type='button'
              @click='openRecoveryModal'
            ) {{ $l10n("FORGET_PASSWORD") }}

      .form__footer
        .form__button
          Button(
            :label='$l10n("ENTRY")'
            class-list='is-wide'
          )
        //- .form__or(
        //-   :data-text='$l10n("OR")'
        //- )
        //- .form__oauth
        //-   OAuth(
        //-     :providers='["google", "vkontakte", "odnoklassniki", "facebook"]'
        //-   )
    .form__bottom
      p.form__text {{ $l10n("DONT_REGISTER") }}
      .form__button
        Button(
          :label='$l10n("REGISTRATION")'
          @click='openRegisterModal'
          class-list='is-wide is-bordered is-register'
        )

</template>
<script>
import Button from "@/components/Button/Button";
import Input from "@/components/Input/Input";
import Checkbox from "@/components/Checkbox/Checkbox";
import OAuth from "@/components/OAuth/OAuth";

import { required, minLength, email } from "vuelidate/lib/validators";
import { mapActions } from "vuex";

export default {
  name: "LoginFormTemplate",
  data() {
    return {
      loading: false,
      asyncError: null,
      form: {
        email: "",
        password: "",
        remember: true
      }
    };
  },
  validations: {
    form: {
      email: {
        email,
        required
      },
      password: {
        required,
        minLength: minLength(8)
      }
    }
  },
  components: { Button, Input, Checkbox, OAuth },
  computed: {
    classList() {
      return {
        "has-error": Boolean(this.asyncError),
        "is-dirty": this.$v.$dirty,
        "is-loading": this.loading
      };
    }
  },
  methods: {
    ...mapActions({
      userLogin: "user/login",
      openModal: "modal/open"
    }),
    resetError() {
      this.$v.$reset();
      this.asyncError = null;
    },
    async login() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.loading = true;

        const { error } = await this.userLogin({
          email: this.form.email.toLowerCase(),
          password: this.form.password,
          remember: this.form.remember
        });

        this.loading = false;

        if (error) {
          this.asyncError = error;
        }
      }
    },
    openRegisterModal() {
      this.openModal("register");
    },
    openRecoveryModal() {
      this.openModal("forgotPassword");
    }
  }
};
</script>
